module.exports = __webpack_public_path__ + "img/cp3-6.2514c620.jpg";